import { render, staticRenderFns } from "./StepsSecondCourse.vue?vue&type=template&id=0bff69f2&scoped=true"
import script from "./StepsSecondCourse.vue?vue&type=script&lang=js"
export * from "./StepsSecondCourse.vue?vue&type=script&lang=js"
import style0 from "./StepsSecondCourse.vue?vue&type=style&index=0&id=0bff69f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff69f2",
  null
  
)

export default component.exports